import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { addCategory, addVirtualUser, getCountries } from "services/ApiService"
import { useNavigate } from "react-router-dom"
import { ReactComponent as LeftSideArrow } from "../../assets/images/arrow-left-short.svg"

// import { addCategory } from "services/ApiService";

const AddVirtualUsers = props => {
  // var navigate = useNavigate()
  //meta title
  document.title = "Add Virtual Users | Stelo - Steel Trading Dashboard "

  const [firstname, setFirstname] = useState("")
  const [lastname, setLastname] = useState(false)
  const [email, setEmail] = useState(false)
  const [countryId, setLCountryId] = useState(false)
  const [countries, setCountries] = useState([])
  const [saveLoader, setSaveLoader] = useState(false)

  // var navigate = useNavigate()

  var submitHandle = e => {
    e.preventDefault()
    setSaveLoader(true)
    var reqObj = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      countryId: countryId,
    }

    console.log("reqObj: " + reqObj)

    addVirtualUser(reqObj)
      .then(res => {
        setSaveLoader(false)
        window.location.href = "/v-users"
        toast.success(res.msg)
      })
      .catch(err => {
        setSaveLoader(false)
        if (err?.errors) {
          setSaveLoader(false)
          err.errors.forEach(error => toast.error(error.msg))
        } else {
          setSaveLoader(false)

          toast.error(err?.message || "An error occurred")
        }

        console.log(err)
      })
  }

  var getCountryList = () => {
    getCountries()
      .then(res => {
        setCountries(res.data)
        // console.log("countries....",res.data)
      })
      .catch(err => {
        if (err?.response?.data?.errors) {
          err?.response?.data?.errors.forEach(error => {
            console.log(error.msg)
            toast.error(error.msg)
          })
        } else {
          // toast.error(err?.response?.data?.message || "An error occured")
        }
        console.log(err)
      })
  }

  useEffect(() => {
    getCountryList()
  }, [])

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Virtual User" breadcrumbItem="Add Virtual User" />
          <Row
            className="justify-content-center align-items-center"
            style={{ minHeight: "50vh" }}
          >
            <div className="">
              <button
                className="badge bg-primary d-inline-block font-size-11 text-center border-0 "
                style={{
                  padding: "6px 16px",
                  minWidth: "100px",
                  borderRadius: "15px",
                }}
                onClick={() => (window.location.href = "/v-users")}
              >
                <LeftSideArrow className="back-icon" /> Go Back..
              </button>
            </div>
            <Col xl={6} className="m-auto">
              <Card
                style={{
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#f9f9f9", // Light background color
                  borderRadius: "8px", // Rounded corners
                }}
              >
                <CardBody>
                  <Form onSubmit={submitHandle}>
                    <Row className="mb-4">
                      <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label"
                      >
                        First Name
                      </Label>
                      <Col sm={6}>
                        <Input
                          type="text"
                          className="form-control"
                          //   value={categoryName}
                          id="horizontal-firstname-Input"
                          placeholder="Enter Firstname"
                          required
                          onChange={e => setFirstname(e.target.value)}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Label
                        htmlFor="lastnname"
                        className="col-sm-3 col-form-label"
                      >
                        Last Name
                      </Label>
                      <Col sm={6}>
                        <Input
                          type="text"
                          className="form-control"
                          //   value={categoryName}
                          id="lastnname"
                          placeholder="Enter Lastname"
                          required
                          onChange={e => setLastname(e.target.value)}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Label
                        htmlFor="email"
                        className="col-sm-3 col-form-label"
                      >
                        Username
                      </Label>
                      <Col sm={6}>
                        <Input
                          type="text"
                          className="form-control"
                          //   value={categoryName}
                          id="email"
                          placeholder="Enter Username "
                          required
                          onChange={e => setEmail(e.target.value)}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label"
                      >
                        Country
                      </Label>
                      <Col sm={6}>
                        <select
                          name=""
                          id=""
                          className="form-control"
                          onChange={e => setLCountryId(e.target.value)}
                        >
                          <option value={""}>Select Country</option>

                          {countries.map((country, key) => (
                            <option key={key} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </Col>
                    </Row>

                    <Row className="justify-content-center">
                      <Col sm={9} className="d-flex justify-content-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                          >
                            {saveLoader ? (
                              <div
                                className="spinner-border spinner-border-sm text-light mx-5"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              " Submit"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddVirtualUsers
